import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {Button, DialogContentText} from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import LoadingButton from "@mui/lab/LoadingButton";
import Dialog from "@mui/material/Dialog";
import {useTranslation} from "react-i18next";

interface ConfirmDeleteDialogProps {
    isDeleteModalVisible: boolean;
    isDeleting: boolean;
    handleCloseDeleteModal: () => void;
    handleDelete: () => void;
    title: string;
    message: string;
    handleExitedModal?: () => void;
}

function ConfirmDeleteDialog(
  {
      isDeleteModalVisible,
      isDeleting,
      handleCloseDeleteModal,
      handleDelete,
      title,
      message,
      handleExitedModal,
  }: ConfirmDeleteDialogProps) {

    const {t} = useTranslation();

    return (
      <Dialog
        open={isDeleteModalVisible}
        onClose={handleCloseDeleteModal}
        TransitionProps={{
            onExited: handleExitedModal,
        }}
      >
          <DialogTitle>
              {title}
          </DialogTitle>

          <DialogContent>
              <DialogContentText>
                  {message}
              </DialogContentText>
          </DialogContent>

          <DialogActions sx={{justifyContent: "space-between"}}>
              <LoadingButton
                loading={isDeleting}
                type="submit"
                variant="contained"
                color="error"
                onClick={handleDelete}
              >
                  {t("Delete")}
              </LoadingButton>

              <Button onClick={handleCloseDeleteModal}>
                  {t("Cancel")}
              </Button>
          </DialogActions>
      </Dialog>
    );
}

export default ConfirmDeleteDialog;
